import * as React from 'react';
import { st, classes, vars } from './Ellipsis.st.css';
import Tooltip from '../Tooltip';
const EllipsisBase = React.forwardRef(({ children, setEllipsis, maxLines, onMouseEnter, onMouseLeave, reference }, ref) => React.cloneElement(children, {
    ...children.props,
    ref,
    onMouseEnter: (e) => {
        if (maxLines >= 1 &&
            reference.current &&
            'offsetHeight' in reference.current) {
            const { offsetHeight, scrollHeight } = reference.current;
            setEllipsis(offsetHeight < scrollHeight);
        }
        if (onMouseEnter) {
            onMouseEnter(e);
        }
    },
    onMouseLeave,
    className: st(classes.root, { hasEllipsis: maxLines > 0 }, children.props.className),
    style: { [vars.maxLines]: maxLines },
}));
const Ellipsis = ({ dataHook, children, maxLines = 1, }) => {
    const [hasEllipsis, setEllipsis] = React.useState(false);
    return (React.createElement(Tooltip, { dataHook: dataHook, content: hasEllipsis && React.Children.only(children).props.children }, (refs) => (React.createElement(EllipsisBase, { children: children, reference: refs.reference, setEllipsis: setEllipsis, maxLines: maxLines }))));
};
export default Ellipsis;
//# sourceMappingURL=Ellipsis.js.map